export default __webpack_public_path__ + "static/media/filter-selected.449db7a5.svg";